module.exports = __webpack_public_path__ + "static/media/mobileMenu3.161fb947.jpeg";